import { FlightDetailsInfoList } from "@flights/search-ui";
import React from "react";
import useFlightDetailsInfoController from "./useFlightDetailsInfo.controller.js";
import { Spinner, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { isOfMetaOrigin } from "../../../../../utils/marketing-url-params.js";
const FlightDetailsInfoMobile = ({ flight, fetchStatus }) => {
    const { isLoading, items, initialItems } = useFlightDetailsInfoController({ flight, fetchStatus });
    const i18n = useI18n();
    const showBaggageInfoAsap = !isOfMetaOrigin() && flight.includedProducts?.segments.some((product) => product.length > 0);
    const loadingComponent = (React.createElement(Stack, { direction: "row" },
        React.createElement(Spinner, null),
        React.createElement(Text, { variant: "body_2" }, i18n.trans(t("flights_fd_loading_more")))));
    if (showBaggageInfoAsap) {
        return (React.createElement(React.Fragment, null,
            React.createElement(FlightDetailsInfoList, { attributes: { "data-testid": "flightdetails_ancillaries" }, variant: "one-column", items: isLoading ? initialItems : items }),
            isLoading ? loadingComponent : undefined));
    }
    return (React.createElement(FlightDetailsInfoList, { attributes: { "data-testid": "flightdetails_ancillaries" }, variant: "one-column", isLoading: isLoading, loadingComponent: loadingComponent, items: items }));
};
export default FlightDetailsInfoMobile;
